import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import OrderDetailView from './OrderDetailView'
import OrderDispatch from 'Store/OrderManagement/Order/OrderDispatch';
import { useNavigate, useParams } from 'react-router-dom';
import permissions, { isAuthorized } from 'client/utils/Permissions';
import { getBulkOrderById } from 'Store/OrderManagement/BulkOrderById/BulkOrderByIdAction';
import { setOrderById } from 'Store/OrderManagement/Order/OrderAction';

const OrderDetailViewContainer = (props: any) => {
  const { isBulkOrder = false, setSelectedKey, tab, tabSwitchClicked, setTabSwitchClicked } = props
  const [mobile, setMobile] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const getOrderDetailById = OrderDispatch.dispatchGetOrderById(dispatch);

  const { orderDetails, getUserDetails, bulkOrderbyIdValue: bulkOrderbyIdValue }: any = useSelector((state: any) => ({
    orderDetails: state.OrderReducer.orderByIdData,
    getUserDetails: state.UserProfile.getUserDetails,
    bulkOrderbyIdValue: state.BulkOrdeByIdReducer.bulkOrderbyIdValue
  }));

  useEffect(()=>{
    if(bulkOrderbyIdValue && isBulkOrder){
        let requestsTemp: any = []
        const bulkOrderbyIdValueTemp = JSON.parse(JSON.stringify(bulkOrderbyIdValue))
        bulkOrderbyIdValueTemp?.searchCriteria?.forEach((item: any) => {
          requestsTemp = [...requestsTemp, ...item.requests]
        })
        bulkOrderbyIdValueTemp.requests = requestsTemp
        bulkOrderbyIdValueTemp.totalItems = bulkOrderbyIdValueTemp?.searchCriteria?.length
        delete bulkOrderbyIdValueTemp?.searchCriteria
        dispatch(setOrderById(bulkOrderbyIdValueTemp))
    }
  }, [bulkOrderbyIdValue])

  useEffect(() => {
    if (tabSwitchClicked) {
      setSelectedKey(tab)
      setTabSwitchClicked(false)
    }
  }, [tabSwitchClicked])

  let { id } = useParams();

  useEffect(() => {
    if (id != undefined && getUserDetails?.permissions?.length > 0) {
      if(isAuthorized(permissions.ApprovalsView) && !isBulkOrder){
        getOrderDetailById(id);
      } else if (isAuthorized(permissions.ViewBulkOrder) && isBulkOrder){
        dispatch(getBulkOrderById({
          orderId: id,
          isEdit: false
        }))
      } else {
        navigate('/ordermanagement/blank');
      } 
    }
  }, [id, getUserDetails?.permissions])

  useEffect(() => {
    const resizeFun = () => {
      if (window.innerWidth < 600) {
        setMobile(true)
      }
      else {
        setMobile(false);
      }
    }
    resizeFun();
    window.addEventListener('resize', resizeFun)
    return () => window.removeEventListener('resize', resizeFun)
  }, []);

  return (
    <OrderDetailView
      orderDetails={orderDetails}
      mobile={mobile}
      isBulkOrder={isBulkOrder}
    />
  )
}

export default OrderDetailViewContainer